export default {
    
    init() {
        const charlimit = document.getElementsByClassName("char-limit");
        const privacyCheckBox = document.querySelectorAll('.form__privacy');
        const istadfondetsuccess = document.querySelector("[data-accordion-form-success]");

        if(privacyCheckBox.length){
            for (const checkbx of privacyCheckBox) {
                checkbx.classList.add('privacy-pro');
                let parnt = checkbx.parentElement;
                parnt.classList.add('privacypolicy__wrapper');
                let sitename = siteGrp.search('istadfiber') != "-1" ? ' Istad Fiber AS ' : ' Istad Kraft AS ';
                parnt.innerHTML = `<div>Ja, jeg godtar at`+ sitename +`bruker informasjonen jeg har oppgitt som beskrevet samt i  
                <a target="_blank" href=${siteUrl}/personvern> personvernerklæringen</a>  vår</div>`;
                parnt.append(checkbx);
            }
        }

        if (istadfondetsuccess) {
            istadfondetsuccess.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" })
        }
        
        if (charlimit.length) {
            for (const chars of charlimit) {
                const charinpt = chars.querySelector('input');
                charinpt.setAttribute("pattern", "\\d*");
            }
        }
    }
}